import { Autocomplete, TextField, Box, Typography, Grid, Button } from "@mui/material";
import { ChevronDown, Check, ArrowRight } from "lucide-react";
import { useContext, useEffect, useState } from "react";

import { AssitanceAdjustViewContext } from "../../../components/AssistanceAdjustList/AssistanceAdjustList";
import grain from "../../../assets/images/grain.png";
import "../AssitanceAdjustModals.scss";

export default function MoveNurseModal() {
	const [actualNurse, setActualNurse] = useState<any>({});
	const [localSelectedReason, setLocalSelectedReason] = useState("");
	const [localSelectedArea, setLocalSelectedArea] = useState("");
	const {
		selectedNurses,
		nurses,
		availableAreas,
		selectedArea,
		selectedReason,
		isModalLoading,
		saveMovements,
		showModal,
		setShowModal,
	} = useContext(AssitanceAdjustViewContext);

	const changeReason = [
		{
			key: "Apoyo en área",
			item: "Apoyo en área",
		},
		{
			key: "Apoyo en área por demanda hospitalaria",
			item: "Apoyo en área por demanda hospitalaria",
		},
		{
			key: "Apoyo en área por complejidad de paciente",
			item: "Apoyo en área por complejidad de paciente",
		},
		{
			key: "Acuerdo personal",
			item: "Acuerdo personal",
		},
	];

	useEffect(() => {
		setActualNurse(nurses.find((e: any) => e.id === selectedNurses[0]));
	}, [selectedNurses]);

	useEffect(() => {
		setLocalSelectedReason(selectedReason);
		setLocalSelectedArea(selectedArea);
	}, [showModal]);

	const canSave = (): boolean => {
		return localSelectedArea !== "" && localSelectedReason !== "";
	};

	const handleSave = () => {
		saveMovements({ area: localSelectedArea, reason: localSelectedReason });
	};

	return (
		<Box>
			<Box className="modal-header">
				<img
					className="modal-header__grain"
					src={grain}
					alt="background"
				/>
				<Box className="modal-header__title">
					<ArrowRight className="modal-header__title__icon" />
					<Box className="modal-header__title__text">
						<Typography className="modal-header__title__text--name">
							Mover Profesional
						</Typography>
						<Typography className="modal-header__title__text--description">
							Mueve un profesional de un sector a otro.
						</Typography>
					</Box>
				</Box>
			</Box>
			<Box
				className="modal-form"
				sx={{ display: "flex", flexDirection: "column", marginTop: "2%" }}
			>
				<Box>
					<Box sx={{ display: "flex" }}>
						<Typography
							className="modal-form__input-title--lighter"
							sx={{
								marginRight: "3%",
							}}
						>
							Profesional
						</Typography>
						<Typography className="modal-form__input-info">
							{actualNurse?.nursename}
						</Typography>
					</Box>

					<Box sx={{ display: "flex" }}>
						<Typography
							className="modal-form__input-title--lighter"
							sx={{
								marginRight: "3%",
							}}
						>
							Sector Actual
						</Typography>
						<Typography className="modal-form__input-info">
							{actualNurse?.area}
						</Typography>
					</Box>
				</Box>
				<Grid
					sx={{ marginTop: "0%" }}
					container
					spacing={2}
				>
					<Grid
						item
						xs={6}
					>
						<Typography className="modal-form__input-title">Sector Nuevo</Typography>
						<Autocomplete
							id="selectNewSector"
							options={availableAreas
								.sort((a: any, b: any) => a.area.localeCompare(b.area))
								.filter((area: any) => area.area !== "SOPORTE")}
							popupIcon={<ChevronDown className="down-icon" />}
							getOptionLabel={(option: any) => option.area}
							onChange={(e, newValue: any) => {
								setLocalSelectedArea(newValue?.id ?? "");
							}}
							size="small"
							fullWidth
							renderInput={(params) => (
								<TextField
									{...params}
									placeholder="Seleccionar"
									variant="outlined"
									sx={{
										"& .MuiOutlinedInput-root": { height: "3rem" },
									}}
								/>
							)}
							value={
								availableAreas.find((area: any) => area.id === localSelectedArea) ||
								null
							}
						/>
					</Grid>

					<Grid
						item
						xs={6}
					>
						<Typography className="modal-form__input-title">Razón de Cambio</Typography>

						<Autocomplete
							id="selectChangeReason"
							options={changeReason.sort((a, b) => a.item.localeCompare(b.item))}
							getOptionLabel={(option) => option.item}
							popupIcon={<ChevronDown className="down-icon" />}
							onChange={(e, newValue) => {
								setLocalSelectedReason(newValue?.key ?? "");
							}}
							size="small"
							fullWidth
							renderInput={(params) => (
								<TextField
									{...params}
									placeholder="Seleccionar"
									variant="outlined"
									sx={{
										"& .MuiOutlinedInput-root": { height: "3rem" },
									}}
								/>
							)}
							value={
								changeReason.find((reason) => reason.key === localSelectedReason) ||
								null
							}
						/>
					</Grid>
				</Grid>
			</Box>
			<Box
				className="buttons"
				sx={{
					marginTop: "9%",
				}}
			>
				<Button
					className="buttons--close"
					onClick={() => setShowModal(false)}
				>
					Cerrar
				</Button>
				<Button
					id="save-button"
					className="buttons--save"
					startIcon={<Check className="buttons--save__icon" />}
					onClick={() => handleSave()}
					disabled={!canSave() || isModalLoading}
				>
					Guardar
				</Button>
			</Box>
			{isModalLoading && (
				<Box>
					<Box className="loader-container"></Box>
					<Box className="loader-container__loader"></Box>
				</Box>
			)}
		</Box>
	);
}
